import React, { useContext, useEffect, useState } from "react";
import API from "../API";
import './statistics.css'
import Context from "../context";
import {BASE_URL} from "../../config";

//Закомментировать все, убрать статистику, раз комментировать - наоборот
export default function Statistics() {
  const { mainState } = useContext(Context)
  const api = new API()
  
  // type 1 = for teacher
  // 0 = for organization
  const [statisticData, setStatisticData] = useState(null)
  const [isChosen, setIsChosen] = useState(false)
  const [tests, setTests] = useState([])
  const [testID,setTestID] =useState(null)
  
  useEffect(() => {
    api.getTests(false,true).then(data => {
      setTests(data)
    })
  }, [])
  
  function getStatistics(e) {
    setIsChosen(true)
    let userId = localStorage.getItem('id');
    let testId = Number(e.target.value) || null
    api.getStatistics(userId, testId).then(data => {
        setStatisticData(data);
        setTestID(testId);
    })
  
  }
  function getStatisticsFile(){
      let userId = localStorage.getItem('id');
        window.open(BASE_URL+'/users/' + userId + '/tests/' + testID+'/xlsx')
  }
  
  const selectTest = tests.map(item => <option key={`testkey${item.id}`} value={item.id}>{item.name}</option>)
  
  
   useEffect(()=>{
     console.log(statisticData)
   },[statisticData])
  
    const getTable = (data) => {
        if (!data) {
            return null;
        }
  
        const getHeaderTable = () => (
            <tr>
                <td>{data.test_name}</td>
            </tr>
        );
  
        const getTableBody = () => {
            return data?.entities.map((item, i) => {
                return <tr key={i}>
                    <td>{item.name}</td>
                    {item.tasks.map((task) =>
                            task.questions.map((question, k) => <td key={`${task.name} ${k}`}>{question.curr}/{question.max} {!question.is_checked && 'проверяется'}</td>)
                    )}
                    <td>{item?.sum}</td>
                    <td>{item?.percent}</td>
                </tr>;
            });
        };
        const getTableHeadTestBody = () => {
            return<>
                <tr>
                    <td></td>
                    {data?.entities?.[0]?.tasks.map((item, i) => {
                        return  <td key={item.name} colSpan={item.questions.length} className={'statistics_header_question_cell'}>{item.name}</td>
                    })}
                    <td className={'statistics_header_question_cell'}>Сумма баллов</td>
                    <td className={'statistics_header_question_cell'}>Процент</td>
                </tr>
                <tr>
                    <td></td>
                    {data?.entities?.[0]?.tasks.map((task) => {
                        return task.questions.map((question,i)=><td key={i} className={'statistics_header_question_cell'}>{i+1}</td>)
                    })}
                </tr>
  
            </>
        };
  
        return (
            <table>
                <thead>{getHeaderTable()}</thead>
                <tbody>
                    {getTableHeadTestBody()}
                    {getTableBody()}
                </tbody>
            </table>
        );
    };
  return (
      <div className="statistics">
        <select style={{width: "80vw"}} onChange={(e) => {getStatistics(e)}}>
         <option>Выберите тест</option>
         {selectTest}
        </select>
        {isChosen && <button style={{margin: "20px 20px 20px 0"}} onClick={()=>getStatisticsFile()}>Выгрузить</button>}
  
         {statisticData ? <div className="statistics-table-container">
                 <div>средний балл: {statisticData?.average_score}</div>
                 {statisticData && getTable(statisticData)}

         </div>:
              <h1>Нет результата</h1>}
          {/* <h1>Результаты будут доступны после окончания всех этапов тестирования!</h1> */}
      </div>
  )
}